import type { PitchingRulesetPoints } from "./rulesets";

export type PitcherStatLine = Readonly<{
  inningsPitchedOuts: number;
  strikeouts: number;
  earnedRuns: number;
  walks: number;
  hits: number;
  decision?: "W" | "L" | "S";
}>;

/**
 * Derived flags computed at write time in `submitGameStats` / `recompute`.
 * `completeGame` = sole pitcher for his team in this game AND ≥15 outs (5 IP)
 * AND game is final. `shutout` = completeGame AND opponent runs == 0.
 */
export type PitcherDerivedFlags = Readonly<{
  completeGame: boolean;
  shutout: boolean;
}>;

export type PitcherScoringResult = Readonly<{
  fantasyPoints: number;
}>;

export function computePitcherPoints(
  points: PitchingRulesetPoints,
  stats: PitcherStatLine,
  derived: PitcherDerivedFlags = { completeGame: false, shutout: false },
): PitcherScoringResult {
  const decisionBonus =
    stats.decision === "W"
      ? points.perWin
      : stats.decision === "L"
        ? points.perLoss
        : stats.decision === "S"
          ? points.perSave
          : 0;

  const fantasyPoints =
    stats.inningsPitchedOuts * points.perOut +
    stats.strikeouts * points.perStrikeout +
    stats.earnedRuns * points.perEarnedRun +
    stats.walks * points.perWalk +
    stats.hits * points.perHitAllowed +
    decisionBonus +
    (derived.completeGame ? points.perCompleteGame : 0) +
    (derived.shutout ? points.perShutout : 0);

  return { fantasyPoints };
}
